import { useTranslation } from "react-i18next";
import { Button } from "@components/Button";
import { ArrowNarrowLeftIcon } from "@components/icons";
import type { KycFormStep } from "@services/knowYourCustomer/types";

interface IKYCModalPagingProps {
  currentStep: KycFormStep;
  onPreviousButtonClick: () => void;
  onNextButtonClick?: () => void;
  isLoading?: boolean;
}

export const KYCModalPaging: React.FC<IKYCModalPagingProps> = ({
  currentStep,
  onPreviousButtonClick,
  onNextButtonClick,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <div className="absolute left-0 right-0 top-7 m-[0_auto] flex w-fit justify-center gap-3">
      {onPreviousButtonClick && (
        <Button
          icon={ArrowNarrowLeftIcon}
          onClick={onPreviousButtonClick}
          className="justify-center"
          isLoading={isLoading}
        />
      )}
      <p className="flex w-[126px] items-center justify-center rounded-full bg-blue-light px-4 py-2.5 text-sm font-semibold">
        {t(`KYC.modal.paging.step.${currentStep}`)}
      </p>
      {onNextButtonClick && (
        <Button
          icon={ArrowNarrowLeftIcon}
          className="rotate-180 justify-center"
          onClick={onNextButtonClick}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};
